// Homepage Banner Slider

var $status = $(".slick-counter");
var $slickElement = $(".homemain-Bannerslider");

$slickElement.on(
  "init reInit afterChange",
  function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + "/" + slick.slideCount);
  }
);
$slickElement.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 750,
    infinite: false,
    autoplay: false,
    autoplaySpeed: 3000,
});


// =============home feature slider===========================//
$(document).ready(function() {
$('.feature_prd_slider').slick({
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: $('.prev-arrowF'),
  nextArrow: $('.next-arrowF'),
   responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
// Add any additional configuration options as needed
});
});
// =============home feature slider end===========================//

// =============home feature mid slider===========================//
$(document).ready(function() {
$('.feature_mid_prd_slider').slick({
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: $('.prev-arrow-MC'),
  nextArrow: $('.next-arrow-MC'),
   responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
// Add any additional configuration options as needed
});
});
// =============home feature mid slider end===========================//

// AOS.init({
//         disable: function() {
//           var maxWidth = 767;
//           return window.innerWidth < maxWidth;
//         }
//     });


